import { render, staticRenderFns } from "./MaterialIn.vue?vue&type=template&id=6be4a3ce&scoped=true"
import script from "./MaterialIn.vue?vue&type=script&lang=js"
export * from "./MaterialIn.vue?vue&type=script&lang=js"
import style0 from "./MaterialIn.vue?vue&type=style&index=0&id=6be4a3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4a3ce",
  null
  
)

export default component.exports